export default "__VITE_ASSET__CHrc2Qfl__"